<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
    <b-card style="margin: 20px">
      <b-card-body>
        <span v-html="html" class="help-html"/>
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
  .active, .accordion:hover {
    background-color: transparent!important;
  }

  .help-html {
    button:focus {
      outline: none!important;
    }

    .active, .accordion:hover {
      background-color: #ff5955!important;
    }

    .accordion {
      padding: 20px!important;
    }    
  }
</style>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  data() {
    return {
      html: ''
    };
  },
  methods: {
    getHelpHtml(context) {
      axiosHelpers.axiosPost("General/GetHelpHtml", {} , context,
        function(data) {
          context.html = data.ResponseVM.Html.replace('href="javascript:OpenAyuda();"','href="#" id="verMapa"');
        }
      );
    },
    loadScriptsForHtml() {
      var acc = document.getElementsByClassName("accordion");
      var i;

      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

      let self = this;
      document.getElementById("verMapa").addEventListener("click", function () {
        self.$router.push("mapacomercios");
      });
    }
  },
  beforeMount: function() {
    let context = this;
    this.getHelpHtml(context);
  },
  updated() {
    this.loadScriptsForHtml();
  }
}
</script>